import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const IBoxProductAttributesSettingsScheme = z.object({
  product_attribute_product_id:
    themeScheme.SettingSkuScheme.default("").catch(""),
});

export const IBoxProductAttributesMessagesScheme = z.object({});
